import { Service } from "@/constants/cloud-apps.ts";

export enum SecurityAwarenessTraining {
  SECURITY = "security",
  PHISHING = "phishing",
  COMPLIANCE_PCIDDS = "compliancePCIDDS",
  COMPLIANCE_GDPR = "complianceGDPR",
  COMPLIANCE_HIPPA = "complianceHIPPA",
  ADAPTIVE = "adaptive",
}

export enum SecurityAwarenessAction {
  ALLOW_CLOUD_SERVICE = "allowCloudService",
  DISCARD_CONNECTION = "discardConnection",
  EDIT_USERS = "editUsers",
  DELETE_CONNECTION = "deleteConnection",
  RESUME_CONNECTION = "resumeConnection",
  SEE_ASSIGNED_USERS = "seeAssignedUsers",
  ACTIVATE_JOURNEY = "activateJourney",
  RESET_JOURNEY = "resetJourney",
  SEND_COURSE_PREVIEW = "sendCoursePreview",
  SELECT_SAT_LANGUAGE = "selectSatLanguage",
}

export enum ComplianceTraining {
  GDPR = "GDPR",
  HIPAA = "HIPAA",
  PCI_DSS = "PCI_DSS",
}

export enum SatServiceProvider {
  OFFICE_365 = "office365",
  GOOGLE = "google",
  CUSTOM = "custom",
}

export const SatServiceProviderToServiceMap: Partial<Record<Service, SatServiceProvider>> = {
  [Service.OFFICE_365]: SatServiceProvider.OFFICE_365,
  [Service.G_SUITE]: SatServiceProvider.GOOGLE,
};

export const ServiceToSatServiceProviderMap: Partial<Record<SatServiceProvider, Service>> = {
  [SatServiceProvider.OFFICE_365]: Service.OFFICE_365,
  [SatServiceProvider.GOOGLE]: Service.G_SUITE,
};

export enum SatConfigurationStatus {
  SELECTED = "selected",
  ALLOWED = "allowed",
  EMAIL_CONFIRMED = "emailConfirmed",
  EMAIL_SENT = "emailSent",
  PROTECTED_USERS_ASSIGNED = "protectedUsersAssigned",
  ACTIVATED = "activated",
}

export const SatStatusToStepMap = {
  [SatConfigurationStatus.SELECTED]: 1,
  [SatConfigurationStatus.ALLOWED]: 2,
  [SatConfigurationStatus.EMAIL_SENT]: 3,
  [SatConfigurationStatus.EMAIL_CONFIRMED]: 4,
  [SatConfigurationStatus.PROTECTED_USERS_ASSIGNED]: 5,
  [SatConfigurationStatus.ACTIVATED]: 6,
};

export enum CoursePreview {
  CYBER_SECURITY_FUNDAMENTALS = "CYBER_SECURITY_FUNDAMENTALS",
  PHISHING_101 = "PHISHING_101",
  PASSWORDS = "PASSWORDS",
}

export enum SatLocale {
  EN_US = "en-US",
  EN_GB = "en-GB",
  EN_AU = "en-AU",
  ES = "es",
  IT = "it",
  FR = "fr",
}

export const SAT_EU_LOCALES = [SatLocale.EN_GB, SatLocale.ES, SatLocale.IT, SatLocale.FR];
export const SAT_GLOBAL_LOCALES = Object.values(SatLocale);

export const isSATCustomDomain = (name: string | Service) => {
  return !Object.values(Service).includes(name as Service);
};
